import React, { useState } from 'react';
import { productCollectionsLinksPropTyes } from '@Theme/natucare/modules/ProductCollectionsLinks/ProductCollectionsLinksPropTypes';
import Container from '@Theme/natucare/components/Container/Container';
import Picture from '@Theme/natucare/components/Picture/Picture';
import * as styles from './ProductCollectionsLinks.module.scss';
const ProductCollectionsLinks = _ref => {
  let {
    heading,
    tabs,
    hasSixElements = false
  } = _ref;
  if (!heading && !tabs) {
    return null;
  }
  const {
    0: activeTab,
    1: setActiveTab
  } = useState(0);
  return /*#__PURE__*/React.createElement("section", {
    className: `${styles.root} ${hasSixElements ? styles.rootSecondary : ''}`
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("h2", {
    className: styles.rootHeading
  }, heading), /*#__PURE__*/React.createElement("div", {
    className: styles.rootTabList
  }, tabs.map((tab, index) => /*#__PURE__*/React.createElement("span", {
    key: index,
    className: `${styles.rootTab} ${activeTab === index ? styles.rootTabActive : ''}`,
    onClick: () => setActiveTab(index)
  }, tab.label))), /*#__PURE__*/React.createElement("div", {
    className: styles.rootItems
  }, tabs[activeTab].items.map((_ref2, index) => {
    var _picture$xs;
    let {
      heading,
      href,
      picture
    } = _ref2;
    return /*#__PURE__*/React.createElement("div", {
      className: styles.rootItem,
      key: index
    }, (picture === null || picture === void 0 ? void 0 : (_picture$xs = picture.xs) === null || _picture$xs === void 0 ? void 0 : _picture$xs.src) && /*#__PURE__*/React.createElement(Picture, {
      pictureClassname: styles.rootItemPicture,
      imgClassname: styles.rootItemImage,
      xs: {
        src: picture.xs.src
      },
      alt: picture.alt
    }), heading && /*#__PURE__*/React.createElement("h2", {
      className: styles.rootItemHeading
    }, /*#__PURE__*/React.createElement("a", {
      href: href,
      className: styles.rootItemLink
    }, heading)));
  }))));
};
export default ProductCollectionsLinks;